/** Mirrors the limits `Mandark.Learning.StudentAnnotationSet.AnnotationRules` enforces. */
export const NOTE_MAX_LENGTH = 2_000;

export function exceedsNoteLimit(note: string | undefined): boolean {
  return (note?.length ?? 0) > NOTE_MAX_LENGTH;
}
